export const EditableLabel = import(/* webpackChunkName: "EditableLabel" */"./EditableLabel");
export const FunctionIcon = import(/* webpackChunkName: "FunctionIcon" */"./FunctionIcon");